import { createSelector } from "reselect";

import { Datetime } from "@tsp-core/datetime/types";
import { fromBackendDate, isInRange } from "@tsp-core/datetime/utils";

import { UserStoreSegment } from "./interface";

export const selectUserSegment = (state: UserStoreSegment) => state.user;

export const selectUserData = (state: UserStoreSegment) => {
  const segment = selectUserSegment(state);
  return segment.data;
};

export const selectUserParty = (state: UserStoreSegment) => {
  const segment = selectUserSegment(state);
  return segment.data.party;
};

export const selectUserPositions = (state: UserStoreSegment) => {
  const data = selectUserData(state);
  return data.positions;
};

export const selectUserPositionsForDate = createSelector(
  selectUserPositions,
  (_: unknown, date: Datetime) => date,
  (positions, date) => {
    return positions.filter((position) => {
      const from = position.periodFrom ? fromBackendDate(position.periodFrom / 1000) : null;
      const to = position.periodTo ? fromBackendDate(position.periodTo / 1000) : null;

      return isInRange(date, [from, to]);
    });
  },
);
